document.addEventListener("DOMContentLoaded", function () {
    const params = {
        initialCountry: "fr",
        preferredCountries: ['fr'],
        separateDialCode: true,
        formatOnDisplay: false,
        autoPlaceholder: "off",
    };

    const phoneCallingCodeObj = document.querySelector(".phone_calling_code");
    const cellphoneCallingCodeObj = document.querySelector(".cellphone_calling_code");

    const inputPhone = document.querySelector(".contact_phone_field");
    let inputPhoneInstance = null;

    if (inputPhone) {
        inputPhoneInstance = window.intlTelInput(inputPhone, params);

        if (phoneCallingCodeObj && phoneCallingCodeObj.value !== "") {
            inputPhoneInstance.setCountry(phoneCallingCodeObj.value);
        }
    }

    const inputCellphone = document.querySelector(".contact_cellphone_field");
    let inputCellPhoneInstance = null;

    if (inputCellphone) {
        inputCellPhoneInstance = window.intlTelInput(inputCellphone, params);

        if (cellphoneCallingCodeObj && cellphoneCallingCodeObj.value !== "") {
            inputCellPhoneInstance.setCountry(cellphoneCallingCodeObj.value);
        }
    }

    const submitButtons = document.querySelectorAll(".js-form-country-code-submit-button");

    submitButtons.forEach(button => {
        button.addEventListener('click', function () {
            if (phoneCallingCodeObj && inputPhoneInstance) {
                const countryData = inputPhoneInstance.getSelectedCountryData();
                if (countryData.iso2) {
                    phoneCallingCodeObj.value = countryData.iso2;
                }
            }

            if (cellphoneCallingCodeObj && inputCellPhoneInstance) {
                const countryData = inputCellPhoneInstance.getSelectedCountryData();
                if (countryData.iso2) {
                    cellphoneCallingCodeObj.value = countryData.iso2;
                }
            }
        });
    });
});